import type { ToolCallStatus } from "../../domain/toolCallMachine";

export interface ExecutionControlsProps {
  status: ToolCallStatus;
  onRun: () => void;
  onCancel: () => void;
  onReset: () => void;
}

const TERMINAL_STATES: ToolCallStatus[] = ["completed", "error", "cancelled", "permission-denied"];

/** Botón de ejecución con estado y cancelación (04-sistema-visual-y-accesibilidad.md). */
export function ExecutionControls({ status, onRun, onCancel, onReset }: ExecutionControlsProps) {
  if (status === "running") {
    return (
      <button type="button" className="btn btn--ghost" onClick={onCancel}>
        Cancelar ejecución
      </button>
    );
  }

  if (TERMINAL_STATES.includes(status)) {
    return (
      <button type="button" className="btn btn--ghost" onClick={onReset}>
        Ejecutar de nuevo
      </button>
    );
  }

  const waiting = status === "awaiting-permission" || status === "awaiting-confirmation";

  return (
    <button type="button" className="btn btn--primary" onClick={onRun} disabled={waiting}>
      Ejecutar escenario
    </button>
  );
}
